import DiscountVoucherCaptureModal, { CurrentPath } from "./index";

export function DiscountVoucherCaptureModalExamples() {
  return (
    <DiscountVoucherCaptureModal
      isModalOpen={true}
      onModalClose={() => console.log("close")}
      currentPath={CurrentPath.PaymentOptions}
      errorMessage=""
      currentVoucherCode=""
      handleApplyVoucher={(voucherCode: string) => console.log(voucherCode)}
    />
  );
}
